import { render, staticRenderFns } from "./sys_account.vue?vue&type=template&id=78355932&scoped=true"
import script from "./sys_account.vue?vue&type=script&lang=js"
export * from "./sys_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78355932",
  null
  
)

export default component.exports